import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/share-square': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M561.9 158.1L417.9 14.1C387.9-15.9 336 5.1 336 48V105.2C293.6 107.1 252 111.8 215.2 123.2 180.1 134.2 152.2 150.8 132.3 172.6 108.2 199.2 96 232.6 96 271.9 96 333.6 129.2 384.4 180.9 416.7 218.4 440.2 266.1 404 251.9 361 236.4 313.8 234.7 290 336 282.2V336C336 379 388 399.9 417.9 369.9L561.9 225.9C580.7 207.2 580.7 176.8 561.9 158.1zM384 336V232.2C255.3 234.1 166.5 255.3 206.3 376 176.8 357.6 144 324.1 144 271.9 144 162.6 273.1 153 384 152.1V48L528 192 384 336zM408.7 420.5A82.7-82.7 0 0 1 429.7 411.2C437.7 406.2 448 412 448 421.4V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H180C186.6 64 192 69.4 192 76V80.5C192 85.4 189 89.9 184.4 91.6 170.7 97 158 103.2 146.4 110.2A12.1-12.1 0 0 0 140.1 112H54A6-6 0 0 1 48 118V458A6-6 0 0 1 54 464H394A6-6 0 0 1 400 458V432C400 426.7 403.6 422 408.7 420.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/share-square.js
// module id = QacJ
// module chunks = 144